import { reduceNumber } from "@/lib/numerology";

export const biorhythmAt = (birthDate, targetDate = new Date()) => {
  const born=new Date(`${birthDate}T12:00:00Z`); const target=new Date(targetDate); const days=Math.floor((Date.UTC(target.getUTCFullYear(),target.getUTCMonth(),target.getUTCDate())-born.getTime())/86400000);
  const wave=(period)=>Math.sin((2*Math.PI*days)/period);
  return {date:target.toISOString(),days,physical:wave(23),emotional:wave(28),intellectual:wave(33)};
};

export const weeklyBiorhythm = (birthDate, start = new Date()) => Array.from({length:7},(_,index)=>biorhythmAt(birthDate,new Date(start.getTime()+index*86400000)));

export const currentNumerologyCycle = (birthDate, target = new Date()) => {
  const [,month,day]=birthDate.split("-").map(Number); const year=reduceNumber(month+day+target.getFullYear()); const monthCycle=reduceNumber(year+target.getMonth()+1);
  return {personalYear:year,personalMonth:monthCycle,personalDay:reduceNumber(monthCycle+target.getDate())};
};